import { TError, TProDirectoryRevision } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';
import { TEACHER_DIRECTORY_PATH } from './entity';

export const getMyProDirectoryRevisionsQueryKey = () => ['pro-directory', 'my-revisions'];

export const useGetMyProDirectoryRevisionsQuery = (enabled = true) => {
  return useQuery<TProDirectoryRevision[], TError>({
    queryKey: getMyProDirectoryRevisionsQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TProDirectoryRevision[]>(`/${TEACHER_DIRECTORY_PATH}/revisions`);
      return res.data ?? [];
    },
    enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
